/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React, { useEffect, useState } from "react";
import { Loader, TopAuthorsWidget } from "../components";
import { VApplication } from "../../../application";
import { AppNavigatorService, SwitchRolesPageService } from "../../../services";
import { EventBusModule } from "@vlinder-web/event-bus-module-react";
import { Col, Modal } from "react-bootstrap";
import { useSMSwitchRoles } from "../machines";
import toast from "react-hot-toast";
import jwt_decode from "jwt-decode";
import { useHistory } from "react-router-dom";
import { StorageModule } from "@vlinder-web/storage-module-react";
import { routes } from "../../../services/appNavigatorService/config/routes.config.json";
import { pretty } from "@vlinder-web/utils-react";

const is = require("is_js");
const storageSrv = StorageModule.getInstance();
export const ROLES_MODAL_OPEN = "RolesModal:Open";
export const ROLES_MODAL_CLOSE = "RolesModal:Close";

const getSrv = () => {
  const app = VApplication.getInstance();
  return app.getSync(
    "services.SwitchRolesPageService"
  ) as SwitchRolesPageService;
};

const getAppNavService = () => {
  const app = VApplication.getInstance();
  return app?.getSync("services.AppNavigatorService") as AppNavigatorService;
};

export const ContainerComm = (props: any) => {
  const srv = getSrv();
  const loginService = getAppNavService();
  let history = useHistory();

  let token: any = loginService?.getToken();
  const staticPageContentConfig = srv?.getStaticPageContent();

  const eventBus = EventBusModule?.getInstance()?.getEventBus();
  const [visible, setVisible] = useState(false);
  const [box, setBox] = useState(false);

  const { switchRolesMachine, switchRolesState, switchRolesSend } =
    useSMSwitchRoles({});

  const [role, setRole] = useState("");

  useEffect(() => {
    _subscribe();
    return _unsubscribe;
  }, []);

  const _subscribe = () => {
    eventBus.on(ROLES_MODAL_OPEN, _onModalOpen);
  };

  const _unsubscribe = () => {
    eventBus.off(ROLES_MODAL_CLOSE, _onModalClose);
  };

  const _onModalOpen = (props: any) => {
    setVisible(true);
    switchRolesSend("START");
  };

  const _onModalClose = () => {
    setVisible(false);
  };

  useEffect(() => {
    if (
      switchRolesState?.matches("GET_A_USERS_ROLES_FAILED") &&
      switchRolesState?.event?.data?.value
    ) {
      setVisible(false);
      setTimeout(() => {
        toast.error(
          switchRolesState?.event?.data?.value ??
          staticPageContentConfig?.error?.getUsersRolesError?.title
        );
      }, 500);
    }
    if (
      switchRolesState?.matches("SIGN_IN_USER_FAILED") &&
      switchRolesState?.event?.data?.value
    ) {
      setVisible(false);
      setTimeout(() => {
        toast.error(
          switchRolesState?.event?.data?.value ??
          staticPageContentConfig?.error?.getUsersRolesError?.title
        );
      }, 500);
    }
    if (switchRolesState?.matches("SIGN_IN_USER_SUCCESS")) {
      const loginSession = storageSrv?.get("userProfile", "session");
      const localSession = storageSrv?.get("userProfile", "local");
      const _token = loginSession ?? localSession;
      console.log(`print 5:`, loginSession);

      if (_token?.accessToken) {
        let decodedToken: any = jwt_decode(_token?.accessToken);
        let currentDate = new Date();
        console.log("decodedToken 5.1 =>", decodedToken);

        setVisible(false);
        if (role === "masq") {
          window.open(`${routes?.Costume?.path}`, "_self");
          history.replace(`${routes?.Costume?.path}`, "_self");
        } else if (role === "committeeMember") {
          window.open(`${routes?.InviteMasqueraderPurchase?.path}`, "_self");
          history.replace(
            `${routes?.InviteMasqueraderPurchase?.path}`,
            "_self"
          );
        } else if (role === "cashier") {
          window.open(`${routes?.CashierPayment?.path}`, "_self");
          history.replace(`${routes?.CashierPayment?.path}`, "_self");
        } else if (role === "admin" || role === "superAdmin") {
          window.open(`${routes?.SalesReport?.path}`, "_self");
          history.replace(`${routes?.SalesReport?.path}`, "_self");
        } else {
          window.open(`${routes?.MyProfile?.path}`, "_self");
          history.replace(`${routes?.MyProfile?.path}`, "_self");
        }
      }
    }
  }, [switchRolesState]);

  const onRoleSelect = (token: string, role: any) => {
    setRole(role?.name);
    switchRolesSend("GET_ACCESS_TOKEN", {
      payload: {
        jwtToken: token,
        role: role?.uuid,
      },
    });
  };

  const _renderPage = () => {
    if (switchRolesState?.matches("GET_A_USERS_ROLES")) {
      return (
        <Loader
          loadingText={
            staticPageContentConfig?.loading?.getUsersRolesLoading?.title
          }
        />
      );
    }
    if (switchRolesState?.matches("GET_ACCESS_TOKEN")) {
      return (
        <Loader
          loadingText={
            staticPageContentConfig?.loading?.getAccessTokenLoading?.title
          }
        />
      );
    }

    if (
      switchRolesState?.matches("GET_A_USERS_ROLES_SUCCESS") &&
      switchRolesState?.event?.data?.value
    ) {
      return (
        <>
          <Modal.Header closeButton>
            <Modal.Title>Switch Roles</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Col md={12} xs={12}>
              <TopAuthorsWidget
                title={"Select your Role"}
                authors={switchRolesState?.event?.data?.value?.roles}
                onRowClick={onRoleSelect.bind(null, token)}
              />
            </Col>
          </Modal.Body>
        </>
      );
    }
  };

  return (
    <Modal
      show={visible}
      onHide={() => setVisible(false)}
      backdrop={false}
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      {_renderPage()}
    </Modal>
  );
};
